import { useState } from 'react';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import { TEDEKBokforderTYPEnum } from '../../../../../globalQueryTypes';
import {
  BusinessCollectionCompType,
  IObjektVy,
} from '../../../../../Types/ObjektVy';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import { BokforderDetaljvy } from './detaljvyer/BokforderDetaljvy';
import { UtanordningDetaljvy } from './detaljvyer/UtanordningDetaljvy';
import query from '../Bokforder/Queries/BokforderTypeQuery.gql';
import {
  BokforderTypeQuery,
  BokforderTypeQueryVariables,
  BokforderTypeQuery_node_TEDEKBokforder,
} from '../Bokforder/Queries/_QueryTypes/BokforderTypeQuery';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import {
  getBokforderTypeFromSearchParams,
  getBokforderVariantFromSearchParams,
  translateTEDEKBokforderVariantToUtbetalningskategori,
} from './Utils/BokforderUtils';
import { useNavigate, useLocation } from 'react-router';

const Bokforder: BusinessCollectionCompType = props => {
  const navigate = useNavigate();
  const location = useLocation();

  const [editMessageID, setEditMessageID] = useState<string>('');

  const { nodeData, loading } = useSelectedDetailQuery<
    BokforderTypeQuery,
    BokforderTypeQuery_node_TEDEKBokforder,
    BokforderTypeQueryVariables
  >(query, props.id, {});

  const type = props.isNew
    ? getBokforderTypeFromSearchParams(location.search)
    : nodeData?.TYP;

  const variant = props.isNew
    ? getBokforderVariantFromSearchParams(location.search) ?? null
    : nodeData?.Variant;

  const utbetalningsKategori =
    translateTEDEKBokforderVariantToUtbetalningskategori(variant);

  if (props.isNew && !loading && type == null) {
    const pathArray = location.pathname.split('/').slice(0, -1);

    navigate(pathArray.join('/') + '/ny?type=BOKFORINGSORDER&variant=TOM');
  }

  return (
    <>
      {type == null && <EDAvenyProgress />}
      {type === TEDEKBokforderTYPEnum.UTANORDNING && (
        <UtanordningDetaljvy
          id={props.id}
          config={props.config}
          editMessageID={editMessageID}
          setEditMessageID={setEditMessageID}
          isNew={props.isNew}
          type={type}
          variant={variant}
          utbetalningsKategori={utbetalningsKategori}
        />
      )}

      {type === TEDEKBokforderTYPEnum.BOKFORINGSORDER && (
        <BokforderDetaljvy
          id={props.id}
          config={props.config}
          isNew={props.isNew}
          type={type}
          editMessageID={editMessageID}
          setEditMessageID={setEditMessageID}
          variant={variant}
        />
      )}
    </>
  );
};

const BokforderObjektVy = collectionCompToObjektVy(Bokforder, 'Bokforder');

export const BokforderVyer: IObjektVy[] = [BokforderObjektVy];
